import { render, staticRenderFns } from "./SaveHousemateModal.vue?vue&type=template&id=88ccfb6a&scoped=true"
import script from "./SaveHousemateModal.vue?vue&type=script&lang=js"
export * from "./SaveHousemateModal.vue?vue&type=script&lang=js"
import style0 from "./SaveHousemateModal.vue?vue&type=style&index=0&id=88ccfb6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ccfb6a",
  null
  
)

export default component.exports